










import Vue from 'vue';
import store from '@/store';

import PacketCreator from '@/components/PeerGroupPacketCreator.vue';
import { BasePacket } from '@/models/packet';

export default Vue.extend({
  props: {
    peerGroupId: {
      type: Number,
      default: null
    }
  },

  components: {
    PacketCreator
  },

  computed: {
    organizationId(): number {
      return store.state.org.basic.organizationId;
    }
  },

  methods: {
    findBasePacket() {
      this.$router.push({
        name: 'OrganizationPacketCreatorLibrary',
        params: {
          organizationId: `${this.organizationId}`,
          peerGroupId: `${this.peerGroupId}`
        }
      });
    },

    finishUp({
      createdPacket,
      statusId
    }: {
      createdPacket: BasePacket;
      statusId: number;
    }) {
      store.dispatch.singlePoint.reset();
      store.dispatch.multiPoint.reset();

      if (!this.peerGroupId) {
        this.backToGoals();
      } else {
        this.connectPacketToGroup(createdPacket, statusId);
      }
    },

    backToGoals() {
      this.$router.push({
        name: 'Organization',
        query: { view: '2' }
      });
    },

    async connectPacketToGroup(packet: BasePacket, statusId: number) {
      await store.dispatch.org.addPeerGroupPacketConnection({
        peerGroupId: this.peerGroupId,
        packetId: packet.packetId,
        tempAssociateId: statusId
      });

      this.$router.push({
        name: 'OrganizationPeerGroup',
        params: {
          organizationId: `${this.organizationId}`,
          peerGroupId: `${this.peerGroupId}`
        }
      });
    }
  }
});
